import UserpromotionResource from "./userpromotion.resource";

const userpromotionModule = angular
  .module("app.resources.userpromotion", [])
  .service("Userpromotion", UserpromotionResource);

export default userpromotionModule;



// WEBPACK FOOTER //
// ./src/resources/userpromotion/userpromotion.module.js